import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from 'stimulus-use'

// Connects to data-controller="drawers"
export default class extends Controller {

  connect() {
    useClickOutside(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)

    const event = new CustomEvent('modals:close', {bubbles: true})
    window.dispatchEvent(event)

    const panelElement = document.getElementById("drawers-panel")
    const backdropElement = document.getElementById("drawers-backdrop")

    if (panelElement && backdropElement) {
      panelElement.classList.add('translate-x-full')

      setTimeout(() => {
        panelElement.classList.remove('translate-x-full')
        panelElement.classList.add('translate-x-0')
        backdropElement.classList.remove('opacity-0')
        backdropElement.classList.add('opacity-100')
      }, 10)
    }
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeydown)
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    const drawersFrame = document.querySelector('turbo-frame#drawers')
    const panelElement = document.getElementById('drawers-panel')
    const backdropElement = document.getElementById("drawers-backdrop")

    if (drawersFrame && panelElement && backdropElement) {
      panelElement.classList.remove('translate-x-0')
      panelElement.classList.add('translate-x-full')
      backdropElement.classList.remove('opacity-100')
      backdropElement.classList.add('opacity-0')

      setTimeout(() => {
        drawersFrame.innerHTML = ''
      }, 500)
    }
  }
}
